<mat-card class="client-card" [routerLink]="['/clients', client.id]">
  <mat-card-content class="client-content">
    <div class="client-info">
      <span class="client-name">{{ client.last_name }} {{ client.first_name }}{{ client.middle_name ? ' ' + client.middle_name : '' }}</span>
      <span class="client-phone">{{ client.phone | mask: '0 (000) 000-00-00' }}</span>
    </div>
    <mat-icon class="chevron">chevron_right</mat-icon>
  </mat-card-content>
</mat-card>
